const en = {
  welcomeMessage: 'Welcome aboard',
  home: 'Home',
  dashboard: 'Dashboard',
  eServices: 'EServices',
  appointments: 'Appointment',
  appointmentDetails: 'Appointment Details',
  servieDetails: 'Service Details',
  appointmentCard: 'Appointment Card',
  requestNewAppointment: 'Request New Appointment',
  newRequest: 'New Request',
  newest: 'newest',
  oldest: 'oldest',
  sortAs: 'Sort by',
  instructions: 'Instrucation',
  requestAppointmentForensicFacilities: 'Book an appointment to visit the judicial facilities',
  appointmentForensicFacilities: 'Appointment to visit the judicial facilities',
  bookEndorsement: 'I confirm that I have read all instructions for booking an appointment',
  continue: 'Continue',
  cancel: 'Cancel',
  confirm: 'Confirm',
  back: 'Back',
  moveBack: 'Back',
  actions: 'Actions',
  warning: 'Warning',
  activeAppointment: 'Active',
  bookAppointment: 'Book Appointment',
  addToCalendar: 'Add to Calendar',
  procedures: 'Procedures',
  cancelbookAppointment: 'Cancel Book Appointment',
  cancelbookAppointmentSuccess: 'Appointment deleted successfully',
  cancelbookAppointmentRequestSuccess: 'Incorrect Appointment request',
  cancelbookAppointmentNotFound: 'Appointment Not Found',
  cancelbookAppointmentRequestNotFound: 'Appointment Request Not Found',
  requestDetails: 'Requested Service Description',

  underStudying: 'Under Studying',
  existing: 'Active',
  rejectionReasons: 'Rejection Reasons',

  pending: 'Under Studying',
  canceled: 'Canceled',
  rejected: 'Rejected',
  active: 'Active',

  congratulations: 'Congratulations!',
  successfullyAdded: 'Your request has been received to book a new appointment to visit the judicial facilities. You will be notified by text message if your request is accepted or rejected, knowing that the earliest available appointment will be booked upon approval of your request',

  confirmNewRequest: 'Confirm Appointment Request',
  willBookEarlist: 'The earliest available appointment will be booked',
  confrimRequest: 'Confirm Request',

  areYouSureToCancelAppointment: 'Are You sure to cancel the Appointment?',
  confirmCancelAppointment: 'Confirm Cancel the Appointment',

  areYouSureToCancelRequest: 'Are You sure to cancel the Request?',
  confirmCancelRequest: 'Confirm Cancel the Request',

  appointmentStatus: 'Appointment Status',
  appointmentCategory: 'Appointment Category',
  service: 'Service',
  place: 'Site',
  dateAndTime: 'Date And Time',
  date: 'Date',
  time: 'Time',
  cancelAppointment: 'Cancel Appointment',
  appointmentNumber: 'Appointment Number',
  searchPlaceholder: 'Search',
  filterByStatus: 'Appointment Status',

  filterAppointmentsWith: 'Search for Appointment with ({text})',
  fetchingData: 'Loading ...',
  NoSearchResultsFor: 'No search results for ',
  noAppointmentsFound: 'No Appointments found',
  gregorian: 'Gregorian',
  hijri: 'Hijri',
  filterWithDate: 'Filter with Date',

  protectAlertHeadTitle: 'Requirement for the inmates to enter the judicial facilities',
  protectAlertDescription: 'For the sake of your safety, we apologize for not receiving any beneficiary who is not in a state of health.',

  inputDateRange: 'Please Enter Date Range',

  locationDetails: 'Location Details',
  serviceDetails: 'Service Details',
  nextText: 'Next',
  cancelText: 'Cancel',
  cancelRequestConfirmation: 'Cancel request confirmation',
  cancelRequestConfirmationText: 'Cancel request confirmation Text',
  cancelRequest: 'Cancel request',
  retreat: 'retreat',
  prevText: 'Previous',
  requestReview: 'Request Review',
  region: 'Region',
  department: 'Department',
  site: 'Site',
  iHaveRead: 'I acknowledge that I have read',
  termsAndConditions: 'Terms and Conditions',
  confirmRequest: 'Confirm Request',
  unAvailable: 'Unavailable',
  edit: 'Edit',
  requestSuccededPlaceholderTitle: 'The request to book an appointment to visit a justice facility has been successfully submitted',
  requestSuccededPlaceholderText: 'Your request for {requestNumber} has been received and you will be notified if the request status is updated',
  requestInfo: 'Request Info',
  backToHome: 'Back to Home',
  viewRequestStatus: 'View request status',
  serviceType: 'Service type',
  day: 'Day',
  appointmentDate: 'Appointment date',
  appointmentTime: 'Appointment time',
  location: 'Location',
  appointmentTicket: 'Appointment ticket',
  cancelAppointmentConfirmationTitle: 'Are you sure that you want to delete appointment ?',
  cancelAppointmentConfirmationDescription: 'By delete confirmation, the appointment will be deleted permenentaly.',
  backToRequests: 'Back to requests',
  am: 'AM',
  pm: 'PM',
  hijriSuffix: 'H',
  meladiSuffix: 'G',
  importantInfo: 'Important info',
  canAddDateAndTimeFromMobileMsg: 'Dear beneficiary, you can specify the appointment time and date by using the service in the Najiz application for smartphones',

  requestNewAppointmentForm: {
    labels: {
      selectRegion: 'Please Select a Region',
      selectSite: 'Choose Appointment Site',
      selectDepartment: 'Choose Department',
      selectService: 'Choose the service you want to book an appointment for',
    },
  },

  appointmentCardDetails: {
    cancelTitle: 'Cancel Appointment',
    cancelText: 'Are you sure to cancel the appointment?',
    title: 'Appointment Card',
    id: 'Appointment Number',
    active: 'Active',
    inactive: 'Inactive',
    service: 'Service',
    siteName: 'Site',
    socialId: 'Social Id',
    fullName: 'Beneficiary',
  },

  validationsMsgs: {
    fieldIsRequired: 'Field is required',
    onlyNumbers: 'Please enter numbers only',
    maxNumbersLength: 'Max numbers length {length}',
    maxCharsLength: 'Max characters length {length}',
    minNumbersLength: 'Min numbers length {length}',
    minCharsLength: 'Min characters length {length}',
    numbersExactLength: 'Numbers exact length {length}',
    startsWith: 'Should start with {listText}',
  },

  months: {
    gregorian: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June ',
      july: 'July ',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
  },

  serverErrors: {
    NOT_FOUND: 'We cannot serve you at the moment. Please try again later',
    SERVER_ERROR: 'Something went wrong, please try again later',
    NO_DATA_FOUND: 'No data found',
  },
};

export default en;
